import type { SellableModule, SellingPriceUpdateInput } from "../domain";
import type { SellableModuleDto, SellingPriceWriteDto } from "./catalogDtos";

export function sellableModuleFromDto(dto: SellableModuleDto): SellableModule {
  return { ...dto };
}

export function sellingPriceToDto(
  input: SellingPriceUpdateInput,
): SellingPriceWriteDto {
  return { sellingPrice: input.sellingPrice };
}
